import { useEffect } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import config from '../Config'
import { useUi } from '../State/Ui'

/* /app is the smart link (spec 8). The server (proxy/server.js) normally
   answers it: iOS -> App Store, Android -> Google Play, desktop -> Početna
   with the QR modal. This covers reaching /app inside the SPA. */
function storeFor(userAgent) {
  if (/android/i.test(userAgent)) return config.PLAY_STORE_LINK
  if (/iPad|iPhone|iPod/.test(userAgent)) return config.APP_STORE_LINK
  return null
}

export default function AppLink() {
  const [params] = useSearchParams()
  const { openQr } = useUi()
  const store = storeFor(navigator.userAgent || '')

  useEffect(() => {
    if (store) window.location.replace(store)
    else openQr()
  }, [store, openQr])

  if (store) return null
  const to = params.get('to')
  return <Navigate to={to && to.startsWith('/') && !to.startsWith('//') ? to : '/'} replace />
}
